






import Vue from 'vue';
import { Partner } from '@/modules/kartoteka/partner';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { types } from '../../store/types';
import { store } from '../../store/edit/index';

export default Vue.extend({
	name: 'ZakazkaZakaznikSelect',
	components: { PartnerSelect: Partner.components.Select },
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_ZAKAZNIK_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.ZAKAZNIK_CHANGE}`,
			};
		},
		partnerFilter(): Record<string, any> {
			return {
				ZakaznikId: this.ZakaznikId,
				Zakazka: !!(this.ZakaznikIdText && this.ZakaznikId),
			};
		},
	},
});
